export const portfolioData = [
  {
    id: 1,
    name: 'Fitness Club',
    languages: ['Bootstrap','javascript','css'],
    languagesIcons: ['fab fa-bootstrap','fab fa-js','fab fa-css3-alt'],
    source: 'https://fitnessclubone.netlify.app/',
    info: "Ma première utilisation de Bootstrap5, pour le menu burger et un responsive plus aisé. C'est également la première fois que j'utilise une bibbliothèque d'animation JS comme WOW JS",
    picture: './media/projet1.jpg'
  },
  {
    id: 2,
    name: 'Agence Héraclès',
    languages: ['HTML5', 'css', 'javascript',],
    languagesIcons: ['fab fa-html5','fab fa-css3-alt','fab fa-js'],
    source: 'https://agenceimmo.netlify.app/',
    info: "Ici, sur toutes les pages, CSS Grid est à l'honneur ! Et Javascript n'est pas en reste avec deux Sliders de type différent. ",
    picture: './media/projet2.jpg'
  },
  {
    id: 3,
    name: 'Cooking',
    languages: ['react','css'],
    languagesIcons: ['fab fa-react','fab fa-css3-alt'],
    source: 'https://cookingforall3.netlify.app/',
    info: "Mon tout premier site avec React ! Et aussi l'utilisation d'une API, 'TheMealDB' une petite API anglosaxonne qui ressence 250 recettes de cuisine",
    picture: './media/projet3.jpg'
  },
  {
    id: 4,
    name: 'Hébergement',
    languages: ['css','HTML5','SaSS','javascript'],
    languagesIcons: ['fab fa-html5','fab fa-sass','fab fa-js'],
    source: 'https://hebergementcloud.netlify.app/',
    info:"Sur ce site j'ai essayé pour la première fois le pré-processeur Sass ! Auquel j'ai ajouté la puissance de Javascript pour une barre de navigation animée, un accordéon pour la section 'FAQ' et un tableau de tarif dynamique",
    picture: './media/projet4.jpg'
  },
  {
    id: 5,
    name: 'University',
    languages: ['HTML5','php','css'],
    languagesIcons: ['fab fa-html5', 'fab fa-php', 'fab fa-css3-alt'],
    source: 'https://forduniversity.netlify.app/',
    info: "Du pur HTML5 et CSS3 ! C'est également mon premier essai avec PHP pour récupérer les données et le message des utilisateur de la section contact",
    picture: './media/projet5.jpg'
  },
  {
    id: 6,
    name: 'Gym Hélios',
    languages: ['HTML5','css', 'javascript'],
    languagesIcons: ['fab fa-html5','fab fa-css3-alt','fab fa-js'],
    source: 'https://gymhelios.netlify.app/',
    info: "Le principal intérêt de ce site est le script Javascript pour faire apparaître une modale, sinon c'est également du pur HTML5 et CSS3 !",
    picture: './media/projet6.jpg'
  },

  {
    id: 7,
    name: 'Mon CV',
    languages: ['react','SaSS', ],
    languagesIcons: ['fab fa-react','fab fa-sass'],
    //source: 'https://gymhelios.netlify.app/',
    info: "C'est le CV que vous êtes en train de consulter. Créer avec React (mise à jour majeure du 23 Novembre 2021) et SaSS",
    picture: './media/projet7.jpg'
  },

  
]